<div *ngIf="!!clm">
    <dx-validation-group>
        <div class="container mt-1" [formGroup]="clmForm">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-6 col-xl-3 col-lg-3" *ngIf="!multiClmPopup">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    Car Init
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    [readonly]="!isNew"
                                    formControlName="carInit"
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-6 col-xl-3 col-lg-3" *ngIf="!multiClmPopup">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    Car Number
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    [readonly]="!isNew"
                                    formControlName="carNo"
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-xl-6 col-lg-6">
                            <bds-date-time-picker
                                formControlName="clmDateTime"
                                displayFormat="MM/dd/yyyy HH:mm"
                                type="datetime"
                                [readOnly]="!isNew"
                                label="CLM Date"
                                [isValid]="clmForm.controls.clmDateTime.valid"
                            >
                            </bds-date-time-picker>
                        </div>
                        <div class="col-12 col-xl-6 col-lg-6" *ngIf="multiClmPopup">
                            <dx-date-box
                                name="clmProcessedDate"
                                [class.bds-mat-dense-form-field]="dense"
                                class="w-100 bds-dx-custom-material"
                                formControlName="clmProcessedDate"
                                [stylingMode]="dxMatStyle"
                                type="date"
                                dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
                                displayFormat="dd/MM/yyyy"
                                label="CLM Processed Date"
                                validationMessageMode="always"
                                [isValid]="clmForm.controls.clmProcessedDate.valid"
                            >
                            </dx-date-box>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>Location City</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="locationCity"
                                    maxlength="9"
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label
                                    >Location State
                                    <span class="dirty-indicator" *ngIf="highlightDirty"
                                        >*</span
                                    ></mat-label
                                >
                                <mat-select formControlName="locationState">
                                    <mat-option></mat-option>
                                    <mat-option
                                        *ngFor="let item of stateCodeLookup | async"
                                        [value]="item.code"
                                    >
                                        {{ item.code }} - {{ item.description }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>Sight Code</mat-label>
                                <mat-select formControlName="sightCode">
                                    <mat-option
                                        *ngFor="let sightCode of sightCodes"
                                        [value]="sightCode.id"
                                        matTooltip="{{ sightCode.description }}"
                                    >
                                        {{
                                            sightCode
                                                ? kvpDisplayTemplate(sightCode.id, sightCode.name)
                                                : ''
                                        }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    Load/Empty
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <mat-select formControlName="loadEmptyFlag" [readonly]="!isNew">
                                    <mat-option></mat-option>
                                    <mat-option
                                        *ngFor="let item of loadEmptyFlags$ | async"
                                        [value]="item.key"
                                    >
                                        {{ kvpDisplayTemplate(item.key, item.value) }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    Destination City
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="destinationCity"
                                    maxlength="9"
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label
                                    >Destination State
                                    <span class="dirty-indicator" *ngIf="highlightDirty"
                                        >*</span
                                    ></mat-label
                                >
                                <mat-select formControlName="destinationState">
                                    <mat-option></mat-option>
                                    <mat-option
                                        *ngFor="let item of stateCodeLookup | async"
                                        [value]="item.code"
                                    >
                                        {{ item.code }} - {{ item.description }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <dx-select-box
                                class="w-100 bds-dx-custom-material bds-mat-dense-form-field dx-mat-form-field-floatLabel-always"
                                stylingMode="filled"
                                validationMessagePosition="right"
                                validationMessageMode="always"
                                formControlName="road"
                                [dataSource]="railroadDxDataSource"
                                valueExpr="rrScac"
                                [searchEnabled]="true"
                                [searchExpr]="['rrScac']"
                                label="Railroad"
                                [displayExpr]="displayRoad"
                                [isValid]="clmForm.controls.road.valid"
                            >
                            </dx-select-box>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    Train Junction
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <input matInput bdsShoutcase formControlName="trainJunction" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <mat-form-field
                                floatLabel="always"
                                class="w-100"
                                appearance="fill"
                                [class.highlight-dirty]="highlightDirty"
                                [class.bds-mat-dense-form-field]="dense"
                            >
                                <mat-label>
                                    CLM Event
                                    <span class="dirty-indicator" *ngIf="highlightDirty">*</span>
                                </mat-label>
                                <input matInput bdsShoutcase formControlName="clmEvent" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
        </div>
    </dx-validation-group>
</div>
